import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { logCompiledEnvironmentConfiguration } from './app/core/configuration/configuration-diagnostics';
import { environment } from './environments/environment';
import { registerLicense } from '@syncfusion/ej2-base';

// This runs before Angular bootstraps so the active local environment
// replacement is visible even when application initialization fails.
logCompiledEnvironmentConfiguration();

// Registering Syncfusion license key
registerLicense(environment.synfusionLicense);

if (environment.production) {
    enableProdMode();
}

platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch(() => console.error('Application initialization failed.'));
